export const MANAGE_DATA_VARIABLES = {
    MANAGE_DATA_VARIABLES_TITLE: {
        key: 'MANAGE_DATA_VARIABLES_TITLE',
        value: 'MANAGE DATA VARIABLES'
    },
    MANAGE_DATA_VARIABLES_DESCRIPTION: {
        key: 'MANAGE_DATA_VARIABLES_DESCRIPTION',
        value: 'Add an entity to define your organisation entities such as funds, users, patients, applications etc and add variables to define the properties for them (eg: name, dob, awardAmount etc). Please use camel case to define entities or variables.'
    },
    ADD_ENTITY_BUTTON: {
        key: 'ADD_ENTITY_BUTTON',
        value: 'Add Entity'
    },
    ADD_ENTITY_NAME_LABEL: {
        key: 'ADD_ENTITY_NAME_LABEL',
        value: 'Entity Name'
    },
    ADD_ENTITY_NAME_PLACEHOLDER: {
        key: 'ADD_ENTITY_NAME_PLACEHOLDER',
        value: 'Name your entity'
    },
    SAVE_NEW_ENTITY_BUTTON: {
        key: 'SAVE_NEW_ENTITY_BUTTON',
        value: 'Save'
    },
    SAVING_NEW_ENTITY_BUTTON: {
        key: 'SAVING_NEW_ENTITY_BUTTON',
        value: 'Saving'
    },
    CANCEL_NEW_ENTITY_BUTTON: {
        key: 'CANCEL_NEW_ENTITY_BUTTON',
        value: 'Cancel'
    },
    SPECIAL_CHAR_NOT_ALLOWED_ERROR_MESSAGE: {
        key: 'SPECIAL_CHAR_NOT_ALLOWED_ERROR_MESSAGE',
        value: 'Special characters and spaces not allowed'
    },
    CONFIRM_DELETE_ENTITY_TITLE: {
        key: 'CONFIRM_DELETE_ENTITY_TITLE', 
        value: 'Are you sure you want to delete this?' },
    FETCHING_RECORDS_ERROR_MESSAGE: {
        key: 'FETCHING_RECORDS_ERROR_MESSAGE',
        value: 'Error Fetching records. Please try again or contact support.'
    },
    SEARCH_BY_NAME_PLACEHOLDER: {
        key: 'SEARCH_BY_NAME_PLACEHOLDER',
        value: 'Search by the name'
    },
    CANCEL_LABEL: {
        key: 'CANCEL_LABEL',
        value: 'Cancel'
    },
    OK_LABEL: {
        key: 'OK_LABEL',
        value: 'OK'
    },
    CONFIRM_DELETE_ENTITY_DESCRIPTION: {
        key: 'CONFIRM_DELETE_ENTITY_DESCRIPTION',
        value: 'If templates are using this entity, please make sure the usage is removed before deletion.'
    },
};

export const MANAGE_ENTITY_DETAILS = {
    ADD_VARIABLE_BUTTON: {
        key: 'ADD_VARIABLE_BUTTON',
        value: 'Add variable'
    },
    VARIABLE_NAME_COLUMN_HEADER: {
        key: 'VARIABLE_NAME_COLUMN_HEADER',
        value: 'Name'
    },
    VARIABLE_DATA_TYPE_COLUMN_HEADER: {
        key: 'VARIABLE_DATA_TYPE_COLUMN_HEADER',
        value: 'Data Type'
    },
    VARIABLE_MANDATORY_COLUMN_HEADER: {
        key: 'VARIABLE_MANDATORY_COLUMN_HEADER',
        value: 'Required'
    },
    VARIABLE_VALIDATIONS_COLUMN_HEADER: {
        key: 'VARIABLE_VALIDATIONS_COLUMN_HEADER',
        value: 'Validations'
    },
    VALIDATE_MAX_CHARACTERS_LABEL: {
        key: 'VALIDATE_MAX_CHARACTERS_LABEL',
        value: 'Validate max characters'
    },
    VARIABLE_VALIDATIONS_PALCEHOLDER: {
        key: 'VARIABLE_VALIDATIONS_PALCEHOLDER',
        value: 'Please select validations'
    },
    STRING_DATA_TYPE_DROPWDOWN_VALUE: {
        key: 'STRING_DATA_TYPE_DROPWDOWN_VALUE',
        value: 'String'
    },
    DATE_DATA_TYPE_DROPWDOWN_VALUE: {
        key: 'DATE_DATA_TYPE_DROPWDOWN_VALUE',
        value: 'Date'
    },
    VARIABLE_MAX_CHARACTERS_COLUMN_HEADER: {
        key: 'VARIABLE_MAX_CHARACTERS_COLUMN_HEADER',
        value: 'Max Characters'
    },
    VARIABLE_SAMPLE_VALUE_TABLE_HEADER: {
        key: 'VARIABLE_SAMPLE_VALUE_TABLE_HEADER',
        value: 'Sample value'
    },
    DISPLAY_NAME: {
        key: 'DISPLAY_NAME',
        value: 'Display Name'
    },
    VARIABLE_USED_COUNT_COLUMN_HEADER: {
        key: 'VARIABLE_USED_COUNT_COLUMN_HEADER',
        value: 'Used count'
    },
    VARIABLE_USED_COUNT_DESC_COLUMN_HEADER: {
        key: 'VARIABLE_USED_COUNT_DESC_COLUMN_HEADER',
        value: '(displays the number of designs using this variable)'
    },
    VARIABLE_MAXIMUM_VALUES_COLUMN_HEADER: {
        key: 'VARIABLE_MAXIMUM_VALUES_COLUMN_HEADER',
        value: 'Maximum Values'
    },
    VARIABLE_MAXIMUM_VALUES_DESC_COLUMN_HEADER: {
        key: 'VARIABLE_MAXIMUM_VALUES_DESC_COLUMN_HEADER',
        value: '(applicable only for multi value variable)'
    },
    VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE: {
        key: 'VARIABLE_MAXIMUM_VALUE_NOT_APPLICABLE',
        value: 'NA'
    },
    REMOVE_FROM_MULTI_VARIABLE_TOOLTIP: {
        key: 'MAX_VALUES_REMOVE_TOOLTIP',
        value: 'Remove from multi variable'
    },
    CHANGE_TO_MULTI_VARIABLE_TOOLTIP: {
        key: 'MAX_VALUES_REMOVE_TOOLTIP',
        value: 'Change to multi variable'
    },
    VARIABLE_ACTIONS_COLUMN_HEADER: {
        key: 'VARIABLE_ACTIONS_COLUMN_HEADER',
        value: 'Actions'
    },
    VARIABLE_NOT_EDITABLE_ERROR_MESSAGE: {
        key: 'VARIABLE_NOT_EDITABLE_ERROR_MESSAGE',
        value: 'Not editable'
    },
    UPDATE_VARIABLE_TITLE_CONFIRMATION_POPUP: {
        key: 'UPDATE_VARIABLE_TITLE_CONFIRMATION_POPUP',
        value: 'Are you sure you want to update this data?'
    },
    UPDATE_VARIABLE_ACTION_BUTTON: {
        key: 'UPDATE_VARIABLE_ACTION_BUTTON',
        value: 'Update'
    },
    SAVE_VARIABLE_TITLE_CONFIRMATION_POPUP: {
        key: 'SAVE_VARIABLE_TITLE_CONFIRMATION_POPUP',
        value: 'Are you sure you want to save this data?'
    },
    SAVE_VARIABLE_ACTION_BUTTON: {
        key: 'SAVE_VARIABLE_ACTION_BUTTON',
        value: 'Save'
    },
    CANCEL_VARIABLE_ACTION_BUTTON: {
        key: 'CANCEL_VARIABLE_ACTION_BUTTON',
        value: 'Cancel'
    },
    EDIT_VARIABLE_ACTION_BUTTON: {
        key: 'EDIT_VARIABLE_ACTION_BUTTON',
        value: 'Edit'
    },
    DELETE_VARIABLE_TITLE_CONFIRMATION_POPUP: {
        key: 'DELETE_VARIABLE_TITLE_CONFIRMATION_POPUP',
        value: 'Are you sure you want to delete this data?'
    },
    DELETE_VARIABLE_ACTION_BUTTON: {
        key: 'DELETE_VARIABLE_ACTION_BUTTON',
        value: 'Delete'
    },
    VARIABLE_NAME_SEARCH_PLACEHOLDER: {
        key: 'VARIABLE_NAME_SEARCH_PLACEHOLDER',
        value: 'Search {{dataIndex}}'
    },
    VARIABLE_SEARCH_CONFIRMATION_BUTTON: {
        key: 'VARIABLE_SEARCH_CONFIRMATION_BUTTON',
        value: 'Search'
    },
    VARIABLE_SEARCH_CLEAR_CONFIRMATION_BUTTON: {
        key: 'VARIABLE_SEARCH_CLEAR_CONFIRMATION_BUTTON',
        value: 'Clear'
    },
    VARIABLE_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE: {
        key: 'VARIABLE_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE',
        value: 'Name does not include special characters or spaces'
    },
    VARIABLE_MAXIMUM_LENGTH_ERROR_MESSAGE: {
        key: 'VARIABLE_MAXIMUM_LENGTH_ERROR_MESSAGE',
        value: 'Max length of list property should be numeric characters only'
    },
    VARIABLE_MAXIMUM_CHARACTER_ERROR_MESSAGE: {
        key: 'VARIABLE_MAXIMUM_CHARACTER_ERROR_MESSAGE',
        value: 'Max Characters should be numeric characters only'
    },
    VARIABLE_MAXIMUM_LINE_EMPTY_ERROR_MESSAGE: {
        key: 'VARIABLE_MAXIMUM_LINE_EMPTY_ERROR_MESSAGE',
        value: 'Max lines property required.'
    },
    VARIABLE_NAME_PLACEHOLDER: {
        key: 'VARIABLE_NAME_PLACEHOLDER',
        value: 'Variable name'
    },
    VARIABLE_LENGTH_PLACEHOLDER: {
        key: 'VARIABLE_LENGTH_PLACEHOLDER',
        value: 'Variable length'
    },
    VARIABLE_SAMPLE_VALUE_PLACEHOLDER: {
        key: 'VARIABLE_SAMPLE_VALUE_PLACEHOLDER',
        value: 'Variable sample value'
    },
    KEY_REQUIRED_ERROR_MESSAGE: {
        key: 'KEY_REQUIRED_ERROR_MESSAGE',
        value: 'is required.'
    },
    MAX_LINES_REQUIRED_ERROR_MESSAGE: {
        key: 'MAX_LINES_REQUIRED_ERROR_MESSAGE',
        value: "Max lines property required."
    },
    MAXIMUM_LINES_PLACEHOLDER: {
        key: 'MAXIMUM_LINES_PLACEHOLDER',
        value: 'Max lines'
    },
    CANCEL_LABEL: {
        key: 'CANCEL_LABEL',
        value: 'Cancel'
    },
    OK_LABEL: {
        key: 'OK_LABEL',
        value: 'OK'
    }
}

export const ENTITY_RELATION_VARIABLES = {
    SELECT_ENTITY_TEXT: {
        key: 'SELECT_ENTITY_TEXT',
        value: 'Select Entity'
    },
    ADD_NEW_RELATION_BUTTON: {
        key: 'ADD_NEW_RELATION_BUTTON',
        value: 'Add New Relationship'
    },
    ADD_RELATION_BUTTON: {
        key: 'ADD_RELATION_BUTTON',
        value: 'Add'
    },
    DELETE_RELATION_BUTTON: {
        key: 'DELETE_RELATION_BUTTON',
        value: 'Delete'
    },
    ADDING_LABEL: {
        key: 'ADDING_LABEL',
        value: 'Adding'
    },
    HAS_ONE_LABEL: {
        key: 'HAS_ONE_LABEL',
        value: 'Has One'
    },
    HAS_MANY_LABEL: {
        key: 'HAS_MANY_LABEL',
        value: 'Has Many'
    },
    CONFIRM_DELETE_TITLE: {
        key: 'CONFIRM_DELETE_TITLE',
        value: 'Are you sure you want to delete this relationship?'
    },
    CONFIRM_DELETE_DESCRIPTION: {
        key: 'CONFIRM_DELETE_DESCRIPTION',
        value: 'If templates are using this relationship, please make sure the usage is removed before deletion.'
    },
    CONFIRM_YES: {
        key: 'CONFIRM_YES',
        value: 'Yes'
    },
    CONFIRM_NO: {
        key: 'CONFIRM_NO',
        value: 'No'
    },
    ADDED_RELATION: {
        key: 'ADDED_RELATION',
        value: 'Relationship added successfully'
    },
    RELATION_FETCH_FAILED: {
        key: 'RELATION_FETCH_FAILED',
        value: 'Failed to fetch relations'
    },
    ERROR_ON_FETCH: {
        key: 'ERROR_ON_FETCH',
        value: 'An unexpected error occurred while fetching relations.'
    },
    DELETED_RELATION: {
        key: 'DELETED_RELATION',
        value: 'Relationship deleted'
    },
    RELATION_DELETE_FAILED: {
        key: 'RELATION_DELETE_FAILED',
        value: 'Failed to delete relations'
    },
    ERROR_ON_DELETE: {
        key: 'ERROR_ON_DELETE',
        value: 'An unexpected error occurred while deleting relations.'
    },
}